import api from './api';

const scrapeJobApi = {
  // Get all scrape jobs with optional filters
  getScrapeJobs: async (params = {}) => {
    return await api.get('/scrape-jobs', params);
  },
  
  // Get a specific scrape job by ID
  getScrapeJob: async (jobId, progressLimit = 10) => {
    return await api.get(`/scrape-jobs/${jobId}`, { progressLimit });
  },
  
  // Create a new scrape job
  createScrapeJob: async (data) => {
    return await api.post('/scrape-jobs', data);
  },
  
  // Delete a scrape job
  deleteScrapeJob: async (jobId) => {
    return await api.delete(`/scrape-jobs/${jobId}`);
  },
  
  // Get progress items for a scrape job
  getProgressItems: async (jobId, limit = 10) => {
    return await api.get('/progress-items', { 
      jobId, 
      jobType: 'scrapeJob',
      limit
    });
  }
};

export default scrapeJobApi;